import { LogOut } from "lucide-react";
import type { SessionUser } from "../../../shared/auth/access";
import { planDate, today } from "../production-time";

export function ProductionManagerHeader({
  shiftCode,
  shiftHours,
  user,
  onLogout,
}: {
  shiftCode: string;
  shiftHours: string;
  user: SessionUser;
  onLogout: () => Promise<void>;
}) {
  return (
    <header className="production-manager-header">
      <div className="production-manager-brand" aria-label="ANL Üretim Yönetimi">
        <span className="production-manager-mark">
          <img src="/anl-logo-new-2026.webp" alt="ANL" />
        </span>
        <span>
          <small>ANL ÜRETİM</small>
          <strong>Performans merkezi</strong>
        </span>
      </div>

      <div className="production-manager-shift">
        <small>AKTİF VARDİYA</small>
        <strong>{shiftCode}</strong>
        <span>{planDate(today())} · {shiftHours}</span>
      </div>

      <div className="production-manager-session">
        <span className="production-manager-user">
          <span className="production-manager-avatar">{user.initials}</span>
          <span>
            <strong>{user.name}</strong>
            <small>{user.roleLabel}</small>
          </span>
        </span>
        <button
          className="production-manager-logout"
          type="button"
          aria-label="Çıkış yap"
          title="Çıkış yap"
          onClick={() => void onLogout()}
        >
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
}
